import {
  CountryCode,
  Gender,
  IdentificationType,
} from "Infrastructure/Api/Api";
import { getAddressValidationSchema } from "Schemas/addressSchemas";
import type { TFunction } from "Translations/Resources";
import { z } from "zod";

export const getOwnerModalSchema = (t: TFunction) =>
  z.object({
    firstName: z.string(),
    lastName: z.string(),
    gender: z.enum(Gender),
    birthDate: z.date().or(z.string()),
    nationality: z.enum(CountryCode),
    address: getAddressValidationSchema(t),
    partyIdentification: z
      .object({
        identification: z.enum(IdentificationType).nullish(),
        identificationNumber: z.string().nullish(),
        identificationValidFrom: z.string().nullish(),
        identificationValidTo: z.string().nullish(),
        identificationIssuer: z.string().nullish(),
        secondIdentification: z.enum(IdentificationType).nullish(),
        secondIdentificationNumber: z.string().nullish(),
        secondIdentificationValidFrom: z.string().nullish(),
        secondIdentificationValidTo: z.string().nullish(),
        secondIdentificationIssuer: z.string().nullish(),
      })
      .nullish(),
  });

export type OwnerFormData = z.infer<ReturnType<typeof getOwnerModalSchema>>;
